const amountComponentCode = () => {
  return {
    restrict: "E",
    template: require("./template.html"),
    transclude: true,
    scope: true,
    link: (scope, element, _attributes, _controller, transclude) => {
      scope.showCode = false;

      // TODO: the formatCode function could be a lot more robust (e.g. handle
      // multi-line tabbing) and put in its own service.
      // If so, while building the string be sure to:
      // 1) iterate recursively over children, using depth to determine indentation level
      // 2) iterate over element attributes rather than using regex to split them
      const formatCode = codeStr => {
        let elementFromCodeStr = angular.element(codeStr)[0];
        if (elementFromCodeStr.outerHTML.indexOf("amount") === 1) elementFromCodeStr.innerHTML = "";
        const codeStrFromElement = elementFromCodeStr.outerHTML;
        return codeStrFromElement
          .replace("ng-scope", "") // remove ng-scope from class lists
          .replace("class=\"\"", "") // remove class attributes that only had ng-scope
          .replace(/(<[a-zA-Z\-_]*?)\s/g, "$1\n  ") // put first attribute on new line
          .replace(/(".*?")\s/g, "$1\n  ") // put each subsequent attribute on new line
          .replace(/\s(<\/)/g, "\n$1") // put drifting closing tags on new line
          .replace(/>\s?</g, "&gt;\n&lt;") // separate embedded tags into separate lines
          .replace(/</g, "&lt;") // replace left angle brackets with relevant string
          .replace(/>/g, "&gt;") // replace right angle brackets with relevant string
          .trim();
      };

      transclude(scope, (clone) => {
        const codeStr = clone[1].outerHTML;
        const formattedCode = formatCode(codeStr);
        const codeBlock = `<code>${formattedCode}</code>`;
        element.find("*[amount-code-transclude]").append(codeBlock);
      });
    },
  };
};

angular
  .module("avant.customer_applications.directives")
  .directive("amountComponentCode", amountComponentCode);
